import { render, staticRenderFns } from "./ChemFamilies.vue?vue&type=template&id=b277f266&"
import script from "./ChemFamilies.vue?vue&type=script&lang=js&"
export * from "./ChemFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports